import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DcMaintainenceResponse } from '../components/model/dc-maintainence-response';
import { AppConstants } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class DcService {
  constructor(private httpClient: HttpClient) { }



  getDCByNumber(dcNumber): Observable<DcMaintainenceResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("page",1);
    
  return this.httpClient.get<DcMaintainenceResponse>(AppConstants.GET_DC_BY_SEQ+"/"+dcNumber);
  
  } 
  getAllDC(upn): Observable<DcMaintainenceResponse[]> {
    
    return this.httpClient.get<DcMaintainenceResponse[]>(AppConstants.GET_DC+"?upn="+upn);
    
    } 

    updateEmailAddres(dcNumber,emailIds:string[]): Observable<number> {

      return this.httpClient.put<number>(AppConstants.UPDATE_DC_EMAIL+"/"+dcNumber,emailIds);
  
    }

    updateDc(dc,seq): Observable<number> {

      return this.httpClient.put<number>(AppConstants.UPDATE_DC+"/"+seq,dc);
  
    }
}
